import jsPDF from 'jspdf'
import 'jspdf-autotable'

export const locationTable = locs => {
    const doc = new jsPDF('p', 'mm')
    let nbPage = 1
    let head = ['#', 'Date', 'Heure', 'Employé', 'Nom', 'Appel', 'Lieu', 'Marque', 'Plaques', 'Total']
    let options = {
        // theme: 'grid',
        styles: {
            font: 'times'
        },
        headStyles: {
            valign: 'middle',
            halign: 'center'
        },
        bodyStyles: {
            valign: 'middle',
            halign: 'center'
        },
        didDrawPage: () => {
            doc.setFontSize(8)
            doc.setFont(undefined, 'normal')
            doc.setFont('times')
            doc.text(nbPage.toString(), 105, 290, 'center')
            nbPage++
        }
    }
    let body = []
    // for (let dep of deps) {
    //     let temp = []
    //     temp.push(index)
    //     temp.push(dep.date)
    //     temp.push(dep.heure)
    //     temp.push(dep.employe)
    //     temp.push(dep.nom)
    //     temp.push(dep.appel)
    //     temp.push(dep.lieu)
    //     temp.push(dep.marque)
    //     temp.push(dep.plaques)
    //     temp.push(dep.totalFinal)
    //     body.push(temp)
    //     index++
    // }
    doc.autoTable(
        head,
        body,
        options
    )
    doc.save()
}